import {defaultFetch, httpMethod} from "@/scripts/Common/api";
import type {ApiResponse} from "@/scripts/Common/api";
import {getToken} from "@/scripts/Common";
import type {User} from "@/components/users/scripts/types";

const fetchUsers = async (): Promise<ApiResponse<User[]>> => await defaultFetch({
    apiName: 'user',
    bearer: getToken()
});


const createOrUpdateUser = async (user: User, method: httpMethod.PUT | httpMethod.POST)
    : Promise<ApiResponse<User>> => await defaultFetch({
    apiName: 'user',
    options: {
        method,
    },
    body: JSON.stringify(user),
    bearer: getToken()
});


const deleteUser = async (userId: number): Promise<{ error: any }> => {
    const {
        error,
    } = await defaultFetch({
        apiName: 'user',
        options: {
            method: httpMethod.DELETE,
            query: {
                userId: userId
            }
        },
        bearer: getToken()
    });

    return {
        error,
    };
}

export {
    fetchUsers,
    deleteUser,
    createOrUpdateUser
}
